import React from 'react';
import { PopupMenuGroup } from '@atlaskit/menu';
import { NavigationItem } from '@css-xp/graphtypes';
import { isNavigationGroup, isNavigationLink } from '../utils/navigation-utils';
import { NavGroupItem } from './navigation-group-items';
import { NavLinkItem } from './navigation-link-items';
import './navigation-menu.scss';

export const ImgIcon = ({ src, alt }: { src: string; alt: string }) => (
  <img src={src} height={24} width={24} alt={alt} style={{ borderRadius: 3 }} />
);

const NavigationMenu = ({ navItems }: { navItems: NavigationItem[] }) => (
  <PopupMenuGroup>
    {navItems.map((item, index) => {
      if (isNavigationLink(item)) {
        return <NavLinkItem link={item} key={`item-${index}`} />;
      }
      if (isNavigationGroup(item)) {
        return <NavGroupItem group={item} key={`item-${index}`} />;
      }
    })}
  </PopupMenuGroup>
);

export default NavigationMenu;
